import { render, staticRenderFns } from "./dropdown-desktop.vue?vue&type=template&id=66a6ca86&scoped=true&"
import script from "./dropdown-desktop.vue?vue&type=script&lang=js&"
export * from "./dropdown-desktop.vue?vue&type=script&lang=js&"
import style0 from "./dropdown-desktop.vue?vue&type=style&index=0&id=66a6ca86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a6ca86",
  null
  
)

export default component.exports